<template>
    <Section
        :class="slice.slice_label"
        width="md"
    >
        <iframe 
            id="skadeanmalan" 
            src="https://compary.eirpartners.se/fnol" 
            sandbox="allow-scripts
                allow-same-origin
                allow-popups
                allow-forms
                allow-popups-to-escape-sandbox
                allow-top-navigation" 
            style="height: 1592px; 
            width: 100%;"
        />
    </Section>
</template>

<script>
export default {
    props: {
        slice: {
            type: Object,
            required: true,
            default: () => {}
        }
    },
};
</script>

<style lang="scss" scoped>

section::v-deep {
    padding-top: 80px;
    background-color: $lightgray;

    .section-inner {
        background-color: $white;
        padding: 2rem 0;

        @include device(pad) {
            border: 2px solid $green;
        }
    }
}
</style>
